import React from 'react';
import { useParams } from 'react-router-dom';
import AdminDetailProxyComponent from "../../../components/Admin/proxies/AdminDetailProxyComponent";

const AdminDetailProxyPage = () => {
    const params = useParams()
    return <AdminDetailProxyComponent serviceId={ params.serviceId } />;
}

export default AdminDetailProxyPage;